module.exports = __webpack_public_path__ + "img/guide-pin-chats.d556d8df.webp";